"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingSubfooter.css");

var _react = _interopRequireDefault(require("react"));

var _MarketingCarousel = _interopRequireDefault(require("./MarketingCarousel"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _concat = _interopRequireDefault(require("lodash/concat"));

var _slice = _interopRequireDefault(require("lodash/slice"));

var _map = _interopRequireDefault(require("lodash/map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAROUSEL_LEGAL_KEYS = ["csuLegalText", "slpLegalText", "fincoreLegalText"];

var _default = function _default(_ref) {
  var defaultProduct = _ref.defaultProduct,
      legalTextKeys = _ref.legalTextKeys,
      requestInfoUrl = _ref.requestInfoUrl;
  var legalText = (0, _map.default)(legalTextKeys, function (contentKey, index) {
    return /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
      tag: "li",
      contentKey: contentKey,
      key: "legal-".concat(index)
    });
  });
  var carouselText = (0, _map.default)(CAROUSEL_LEGAL_KEYS, function (contentKey, index) {
    return /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
      tag: "li",
      sharedKey: "marketing2020/carouselLegalText",
      contentKey: contentKey,
      key: "carousel-".concat(index)
    });
  });
  var disclaimers = (0, _concat.default)(legalText, carouselText);
  var leftColumnCount = Math.ceil(disclaimers.length / 2);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-subfooter"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "background-chevron",
    alt: "background",
    src: require("../assets/redesign2020/top-background.svg")
  }), /*#__PURE__*/_react.default.createElement(_MarketingCarousel.default, {
    defaultProduct: defaultProduct,
    carouselLegalSuperScript: legalTextKeys.length + 1
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-subfooter-body"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "chevron",
    className: "chevron",
    src: require("../assets/redesign2020/chevron.svg")
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "subfooter-header"
  }, "Ready to make an impact on your employees' financial well-being and your company's bottom line?"), /*#__PURE__*/_react.default.createElement("a", {
    href: requestInfoUrl,
    className: "button",
    target: "_blank"
  }, "Request a demo")), /*#__PURE__*/_react.default.createElement("div", {
    className: "legalTextWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "legalText"
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: "legalTextList"
  }, (0, _slice.default)(disclaimers, 0, leftColumnCount)), /*#__PURE__*/_react.default.createElement("ol", {
    className: "legalTextList",
    start: leftColumnCount + 1
  }, (0, _slice.default)(disclaimers, leftColumnCount)))));
};

exports.default = _default;